import { render, staticRenderFns } from "./RelationList.vue?vue&type=template&id=e0a26c02&scoped=true&"
import script from "./RelationList.vue?vue&type=script&lang=ts&"
export * from "./RelationList.vue?vue&type=script&lang=ts&"
import style0 from "./RelationList.vue?vue&type=style&index=0&id=e0a26c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a26c02",
  null
  
)

export default component.exports